import { useAlert } from '@ads/components-react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { usePostApiV1UserUseridTemporaryPassword } from '@/shared/api/generated';

/**
 * Hook para definir uma senha temporária para um usuário.
 * Chama POST /api/v1/user/:userId/temporary-password.
 * Exibe alerta de sucesso com aviso de expiração em 60 minutos.
 *
 * @param onSuccess - Callback chamado após definição bem-sucedida
 */
export function useTemporaryPassword(onSuccess: () => void) {
  const { alert } = useAlert();
  const { t } = useTranslation('personManagement');

  const { mutate, isPending: isSettingPassword } = usePostApiV1UserUseridTemporaryPassword({
    mutation: {
      onSuccess: () => {
        alert({
          alertType: 'success',
          title: t('enrollmentManagement.tempPasswordModal.successTitle'),
          description: t('enrollmentManagement.tempPasswordModal.successDescription'),
        });
        onSuccess();
      },
    },
  });

  const setTemporaryPassword = useCallback(
    (userId: number, password?: string) => {
      mutate({
        userId,
        data: { temporaryPassword: password ?? null },
      });
    },
    [mutate],
  );

  return { setTemporaryPassword, isSettingPassword } as const;
}
